import { Projects } from './project-list';
import { RUNav } from './Projects/RUNav';
import { PersonalWebsite } from './Projects/PersonalWebsite';
import { NameOfBlog } from './Projects/NameOfBlog';
import { Foodies } from './Projects/Foodies';
import { ECommerce } from './Projects/ECommerce';
import { Tictactoe } from './Projects/TicTacToe';

export const PROJECTS: Projects[] = [
  RUNav,
  PersonalWebsite,
  NameOfBlog,
  Foodies,
  ECommerce,
  Tictactoe,
];
